import React, { createContext, useContext } from 'react';

// True while the sticky page header is condensed (the document has scrolled).
// AppLayout's StickyHeader provides it; HeaderSubtitle consumes it.
export const HeaderScrollContext = createContext(false);

// A page-header subtitle that collapses away (height + opacity + margin → 0)
// when the header condenses on scroll, then returns at the top. Renders a <p>;
// pass the usual font/italic/size classes via className. The collapse drives
// the header's shrink — the title stays, the subtitle disappears.
const HeaderSubtitle = ({ className = '', children, ...rest }) => {
  const scrolled = useContext(HeaderScrollContext);
  return (
    <p
      className={[
        'm-0 overflow-hidden',
        'transition-all duration-300 ease-mogged',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={
        scrolled
          ? { maxHeight: 0, opacity: 0, marginTop: 0, marginBottom: 0 }
          : { maxHeight: '5rem' }
      }
      aria-hidden={scrolled ? 'true' : undefined}
      {...rest}
    >
      {children}
    </p>
  );
};

export default HeaderSubtitle;
